import { useState } from 'react';

import creditIcon from '../../../assets/creditCheck.svg';
import { useSignupRouterUK } from '../../../hooks/useSignupRouter/useSignupRouterUK';
import { Button } from '../../Button/Button';
import styles from '../Decision.module.css';

const CheckSkippedDecision = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { navigateSignup } = useSignupRouterUK();

  const handleNavigateBack = async () => {
    setIsLoading(true);
    await navigateSignup({ route: 'check' });
    setIsLoading(false);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        We were unable to run a soft credit check
      </h1>
      <div className={styles.gifContainer}>
        <img
          data-testid="credit-icon"
          src={creditIcon}
          alt="An ID card with a magnifying glass on top of it"
        />
      </div>
      <div className={styles.body}>
        <div className={styles.bodySection}>
          <p className={styles.bodyContent}>
            To resolve this and receive a loan decision, please contact us using
            the details below.
          </p>
        </div>
        <div className={styles.bodySection}>
          <h3 className={styles.bodyHeading}>Get in touch with iwoca</h3>
          <p className={styles.bodyContent}>
            Call us on{' '}
            <a href="tel:02037780105" target="_blank" rel="noreferrer">
              020 3778 0105
            </a>{' '}
            (Monday to Friday 9am - 6pm)
          </p>
          <p className={styles.bodyContent}>
            Email us at{' '}
            <a
              href="mailto:support@iwoca.co.uk"
              target="_blank"
              rel="noreferrer"
            >
              support@iwoca.co.uk
            </a>
          </p>
        </div>
      </div>
      <Button
        loading={isLoading}
        onClick={handleNavigateBack}
        className={styles.backButton}
      >
        Review my details again
      </Button>
    </div>
  );
};

export default CheckSkippedDecision;
